import React from 'react';

import pluralize from 'pluralize';

import { LeoResponseMessageContext } from '../../../utils/LeoUtils';
import NeoLeoLink from './NeoLeoLink';

export type LearningLink = {
  title: string;
  url: string;
};

type NeoLeoLearningLinksProps = {
  msgContext: LeoResponseMessageContext;
};

const NeoLeoLearningLinks: React.FC<NeoLeoLearningLinksProps> = ({
  msgContext,
}) => {
  let learningLinks: LearningLink[] = [];
  if (msgContext && msgContext?.references?.documents.length > 0) {
    learningLinks = msgContext.references.documents
      .map(({ title, url }) => ({ title, url }))
      .filter((el) => !!el.url);
  }

  if (!learningLinks.length) {
    return null;
  }

  return (
    <div className='flex flex-col gap-3 text-white font-inter'>
      <p className='font-medium text-sm'>
        Click on {pluralize('this', learningLinks.length)}{' '}
        {pluralize('link', learningLinks.length)} to learn more
      </p>
      <div className='text-white font-inter flex flex-col gap-2'>
        {learningLinks.map((link) => (
          <NeoLeoLink key={link.url} title={link.title} url={link.url} />
        ))}
      </div>
    </div>
  );
};

export default NeoLeoLearningLinks;
